import Highcharts from "highcharts";

export const axisLabelFormatter = function (this: Highcharts.AxisLabelsFormatterContextObject) {
  const value = Number(this.value);

  if (value === 0) {
    return "0 TB";
  }

  const formatted = value % 1 === 0 ? value.toString() : value.toFixed(2).replace(/\.?0+$/, "");

  return `${formatted} TB`;
};
